export default __webpack_public_path__ + "static/accelerating-fintech-e6a675cc67ed9d21efc97723dc61a9cc.png";